<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('DOCUMENT_LIST')">
        <slot name="section-document-list">
          <section-document-list ref="DOCUMENT_LIST"
                                 id="DOCUMENT_LIST"
                                 :extended="isExtended('DOCUMENT_LIST')"
                                 :showButton="true"
                                 :autoSave="true"
                                 :readOnly="readOnly"
                                 :moduleId="moduleId"
                                 :searchText="searchText"
                                 :ressourceHeader="ressource"
                                 :fiche="fiche"
                                 :document=selectedDocument
                                 :route="route"
                                 :attribut="attribut"
                                 @extended="setExtended"
                                 @fullscreen="setFullscreen"
                                 @status="updateStatus"
                                 @toggleCardView="toggleCardView"
                                 @updated="documentUpdated"
                                 @selectItem = "selectItem">
          </section-document-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Document from '@/extend/classes/Document';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionDocumentList from '@/extend/sections/SectionDocumentListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionDocumentList,
    FicheHeader,
  },

  props: {
    document: {
      type: Object as PropType<Document>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.DOCUMENT_LIST,
      sections: [
        'DOCUMENT_LIST',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_DOCUMENT_LIST);
    },

    selectedDocument (): Document {
      return this.document
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    documentUpdated (document: Document) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.document || this.document.id < 0) && value == 'DOCUMENT_LIST') {
        this.setExtended(new Extended('DOCUMENT_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
